import React, { Component, useEffect, useRef, useState } from "react";
import { getDate, getDefaultName, getUser, useFormInput, userAvatar } from "../utils";
import {
  addRefereeToCourse,
  blockUser,
  deleteCourseReferee,
  deleteUser,
  loadCourseReferees,
  loadUser,
  login,
  saveAdministrator,
  saveReferee,
  uploadProfileImage,
} from "../utils/Network";


import SelectGender from "../components/SelectGender";
import SelectCountries from "../components/SelectCountries";
import SelectCities from "../components/SelectCities";
import Modal from "react-modal";

export default function AdministratorContent({ id }) {
  const [user, setUser] = useState([]);

  const [birth_year, setBirthYear] = useState(null);
  const [birth_month, setBirthMonth] = useState(null);
  const [birth_day, setBirthDay] = useState(null);
  const [gender, setGender] = useState(null);
  const [courses, setCourses] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [country_id, setCountryID] = useState(null);
  const [city_id, setCityID] = useState(null);

  const [error, setError] = useState(null);
  const [addError, setAddError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [profile_image_file, setProfileImageFile] = useState(false);
  const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);
  const [confirmModalType, setConfirmModalType] = useState(false);
  const [modal_password, setModalPassword] = useState(false);
  const [modal_error, setModalError] = useState(false);
  const [modal_loading, setModalLoading] = useState(false);

  const profile_image_ref = useRef(null);

  var admin = getUser();
  useEffect(() => {
    if (id) {
      loadUser(id).then((profile) => {
        setUser(profile);

        if (profile) {
          if (profile.birth_date) {
            var birthdate = profile.birth_date.split("-");
            setBirthYear(birthdate[0]);
            setBirthMonth(birthdate[1]);
            setBirthDay(birthdate[2]);
          }

          setGender(profile.gender);

          if (profile.country_id) {
            setCountryID(profile.country_id);
          }

          if (profile.city_id) {
            setCityID(profile.city_id);
          }

          
        }
        setLoading(false);
      });
    }
  }, []);

  const handleFileChange = (e) => {
    var file = e.target.files[0];
    if (e.target.files) {
      setProfileImageFile(file);

      setLoading(true);
      uploadProfileImage(user, file).then((response) => {
        console.log(response);
        if (response.id) setUser(response);
        setLoading(false);
      });
    }
  };

  const openConfirmModal = (type) => {
    setConfirmModalType(type);
    setConfirmModalIsOpen(true);
  };
  const closeConfirmModal = () => {
    setConfirmModalIsOpen(false);
  };
  const handleChange = (e) => {
    switch (e.target.name) {
      case "modal_password":
        setModalPassword(e.target.value);
        break;

      default:
        break;
    }
  };

  const modalSubmit = () => {
    switch (confirmModalType) {
      case "Delete":
        deleteThisUser();
        break;
      case "Ban":
        blockThisUser();
        break;
      default:
        break;
    }
  };

  const deleteThisUser = () => {
    setModalLoading(true);
    setModalError(false);
    if (!modal_password) {
      setModalError("Please Enter Password");
      return;
    }

    login({ email: admin.email, password: modal_password }).then((data) => {
      setModalLoading(false);
      if (data.tokens) {
        deleteUser(user.user).then(() => {
          window.location.href = "/cms/administrators";
        });
      } else {
        setModalError(data.detail);
      }
    });
  };

  const blockThisUser = () => {
    setModalLoading(true);
    setModalError(false);
    if (!modal_password) {
      setModalError("Please Enter Password");
      return;
    }

    login({ email: admin.email, password: modal_password }).then((data) => {
      setModalLoading(false);
      if (data.tokens) {
        blockUser(user).then(() => {
          alert("user profile has been deactivated");
        });
        setConfirmModalIsOpen(false);
        setLoading(false);
        var temp = user;
        temp.is_active = temp.is_active ? false : true;
        setUser(temp);
        setLoading(true);
      } else {
        setModalError(data.detail);
      }
    });
  };
  const onChange = (e) => {
    var temp = user;

    //alert(e.target.name)
    switch (e.target.name) {
      case "first_name":
        temp.first_name = e.target.value;
        setUser(temp);
        break;
      case "last_name":
        temp.last_name = e.target.value;
        setUser(temp);
        break;
      case "email":
        temp.email = e.target.value;
        setUser(temp);
        break;
      case "password":
        temp.password = e.target.value;
        setUser(temp);
        break;

      case "year":
        var date = [2021, 1, 1];
        setBirthYear(e.target.value);
        if (user.birth_date) date = user.birth_date.split("-");
        date[0] = e.target.value;
        temp.birth_date = date[0] + "-" + date[1] + "-" + date[2];
        setUser(temp);
        break;
      case "month":
        var date = [2021, 1, 1];
        setBirthMonth(e.target.value);
        if (user.birth_date) date = user.birth_date.split("-");
        date[1] = e.target.value;
        temp.birth_date = date[0] + "-" + date[1] + "-" + date[2];
        setUser(temp);
        break;
      case "day":
        var date = [2021, 1, 1];
        setBirthDay(e.target.value);
        if (user.birth_date) date = user.birth_date.split("-");
        date[2] = e.target.value;
        temp.birth_date = date[0] + "-" + date[1] + "-" + date[2];
        setUser(temp);
        break;

      default:
        break;
    }
  };
  const saveChanges = () => {
    setError(null);
      setLoading(true);
      
      if (!user) {
        setError("Please Enter Name");
        setLoading(false);
        return;
    }

    if (user.first_name===undefined || user.first_name.length < 3) {
      setError("Please Enter Name");
      setLoading(false);
      return;
    }

    if (user.last_name === undefined || user.last_name.length < 3) {
      setError("Please Enter Last Name");
      setLoading(false);
      return;
    }

    if (user.email.length < 5) {
      setError("Please Enter Email");
      setLoading(false);
      return;
    }

    saveAdministrator(user, country_id, city_id).then(function (data) {
      setLoading(false);
      if (data.data && data.data.email)
        window.location.href = "administrators?success=true";
      else setError(JSON.stringify(data.errors, null, 4));
    });
  };

  
  const onValue = (value, name) => {
    var temp = user;
    switch (name) {
      case "gender":
        temp.gender = value;
        setGender(value);
        setUser(temp);
        break;
      case "course":
        setSelectedCourse(value);
        break;
      case "living_country":
        setCountryID(value);
        break;
      case "living_city":
        setCityID(value);
        break;
      default:
        break;
    }
  };
  const year_start = new Date().getFullYear() - 90;
  const year_end = new Date().getFullYear();
  const years_array = range(year_start, year_end);
  const months = new Array(11);
  months[0] = "Jan";
  months[1] = "Feb";
  months[2] = "Mar";
  months[3] = "Apr";
  months[4] = "May";
  months[5] = "Jun";
  months[6] = "Jul";
  months[7] = "Aug";
  months[8] = "Sep";
  months[9] = "Oct";
  months[10] = "Nov";
  months[11] = "Dec";
  const days_array = range(1, 31);

  function range(start, end) {
    var foo = [];
    for (var i = start; i <= end; i++) {
      foo.push(i);
    }
    return foo;
  }

  

  return (
    <>
      <div className="content-wrapper">
        <section class="content-header">
          <h3 className="mb-2"></h3>
          <ol class="breadcrumb">
            <li>
              <a href="dashboard">
                <i class="fa fa-dashboard"></i> Home
              </a>
            </li>
            <li>
              <a href="administrators">
                <i class="fa fa-gavel"></i> Admins
              </a>
            </li>
            <li class="active">Administrator</li>
          </ol>
        </section>

        <Modal
          closeTimeoutMS={500}
          isOpen={confirmModalIsOpen}
          onRequestClose={closeConfirmModal}
          className="Modal confirm-modal"
          overlayClassName="Overlay"
        >
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" onClick={closeConfirmModal}>
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">{confirmModalType} Talent</h4>
            </div>
            <div class="modal-body">
              <div className="" style={{ minHeight: 100 }}>
                <div className="col-md-12 mb-10 text-light">
                  To confirm {confirmModalType}, Please enter your password
                </div>
                <div className="col-md-8">
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="fa fa-lock"></i>
                    </span>
                    <input
                      type="password"
                      className="form-control modal-password"
                      onChange={handleChange}
                      placeholder="Password"
                      name="modal_password"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <button
                    className="btn btn-primary btn-rounded"
                    onClick={modalSubmit}
                  >
                    DELETE
                  </button>
                </div>
              </div>
              {modal_error && (
                <div className="alert alert-danger mb-10 ">{modal_error}</div>
              )}
              {modal_loading && (
                <div className="alert alert-primary mb-10 text-color-light">
                  Please wait...
                </div>
              )}
            </div>
          </div>
        </Modal>

        <section className="content">
          <div className="row">
            <div class="col-md-4">
              <div class="box box-widget widget-user-2">
                <div className="widget-user-header bg-yellow">
                  <div
                    className="widget-user-image pull-right ml2 cursor-pointer"
                    data-toggle="modal"
                    data-target="#modal-profile-image"
                  >
                    <img
                      className="img-circle"
                      onClick={() => {
                        profile_image_ref.current.click();
                      }}
                      src={userAvatar(Array.isArray(user) ? null : user)}
                      alt="User Avatar"
                    />
                    <input
                      ref={profile_image_ref}
                      type="file"
                      className="hide"
                      onChange={handleFileChange}
                    />
                  </div>
                  <div className="pull-left">
                    <h3 className="widget-user-username ml-0">
                      {user &&
                        user.first_name &&
                        user.first_name + " " + user.last_name}
                    </h3>
                  </div>
                  <div className="clear"></div>
                </div>
                <div class="box-footer no-padding">
                  <ul class="nav nav-stacked">
                    <li>
                      <a href="#">
                        Last Login :{" "}
                        <span class="pull-right badge bg-blue">
                          {" "}
                          {user && getDate(user.last_login)}
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <button
                className="btn btn-danger"
                onClick={() => {
                  openConfirmModal("Delete");
                }}
              >
                {" "}
                <i className="fa fa-trash"></i> Delete
              </button>
              <button
                className="btn btn-warning "
                onClick={() => {
                  openConfirmModal("Ban");
                }}
                style={{ marginLeft: 5 }}
              >
                <i className="fa fa-ban"></i>{" "}
                {user && user.is_active ? "Deactivate" : "Activate"}
              </button>
            </div>
            <div className="col-md-8">
              <div class="box box-primary">
                <div class="box-header with-border">
                  <h3 class="box-title">Details</h3>
                </div>
                <div className="box-body padding-20 ">
                  <form className="form-horizontal">
                    <div className="form-group row mb-8">
                      <div className="col-sm-4 mb-8">
                        <input
                          type="text"
                          defaultValue={user && user.first_name}
                          name="first_name"
                          onChange={onChange}
                          className="form-control"
                          placeholder="Name"
                        />
                      </div>
                      <div className="col-sm-4  mb-8">
                        <input
                          type="text"
                          defaultValue={user && user.last_name}
                          name="last_name"
                          onChange={onChange}
                          className="form-control"
                          placeholder="Surename"
                        />
                      </div>
                    </div>

                    <div className="form-group row mb-8">
                      <div className="col-sm-4 mb-8">
                        <input
                          type="text"
                          defaultValue={user && user.email}
                          name="email"
                          onChange={onChange}
                          className="form-control"
                          placeholder="Email"
                        />
                      </div>
                      <div className="col-sm-4  mb-8">
                        <input
                          type="text"
                          name="password"
                          onChange={onChange}
                          className="form-control"
                          placeholder="Password"
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-12 mb-8">
                        <SelectGender
                          border={"1"}
                          width={"200px"}
                          value={gender}
                          callback={onValue}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-12  mb-8">
                        <div className="pull-left margin-r-10  mb-8  max-200">
                          <SelectCountries
                            name={"living_country"}
                            placeholder="From"
                            value={country_id}
                            kurds={1}
                            callback={onValue}
                          />
                        </div>
                        <div className="pull-left max-200">
                          <SelectCities
                            name={"living_city"}
                            key={country_id}
                            country={country_id}
                            value={city_id}
                            callback={onValue}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="box-footer padding-0 padding-t-10">
                      <a
                        href="juries"
                        type="button"
                        className="btn btn-default "
                      >
                        Cancel
                      </a>
                      <button
                        type="button"
                        onClick={saveChanges}
                        disabled={loading}
                        className="btn btn-info pull-right"
                      >
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {error && (
                <>
                  <div className="alert alert-danger ">{error}</div>
                </>
              )}

              {loading && (
                <>
                  <div className="alert alert-info ">please wait...</div>
                </>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
